import { combineReducers } from "redux";
import menu from "./menu";
import auth from "./auth";
import restaurant from "./restaurant";
import settings from "./settings";
import modal from "./modal";
import plan from "./plan";

export default combineReducers({
  menu,
  auth,
  restaurant,
  modal,
  settings,
  plan,
});
